import { createSelector } from '@reduxjs/toolkit';
import { addDays, startOfToday } from 'date-fns';
import { selectDatesValue } from './selectDatesValue';
import { selectDatesLabel } from './selectDatesLabel';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { EPageType } from 'shared/types/page';
import { TButtonSize } from 'shared/types/filters';

const today = startOfToday();

export const selectDatesFilter = createSelector(
  [selectDatesValue, selectDatesLabel, selectPageType, selectIsInlineFiltersRedesigned],
  (
    value,
    label,
    pageType,
    isFiltersRedesignEnabled,
  ): {
    value: typeof value;
    label: typeof label;
    min: Date;
    max: Date;
    size: TButtonSize;
  } => ({
    value,
    label,
    min: today,
    max: addDays(today, 365),
    size: isFiltersRedesignEnabled && pageType === EPageType.MAIN && !!(value.from || value.to) ? 'small' : 'default',
  }),
);
